import React from 'react'

export function FilterValues({
  values,
  showAll,
  setShowAll,
  onRemove,
}: {
  values: string[]
  showAll: boolean
  setShowAll?: (value: boolean) => void
  onRemove?: (item: string, e: any) => void
}) {
  return (
    <>
      {values.length > 3 && !showAll ? (
        <>
          {values.slice(0, 3).map((element) => (
            <div key={element} className="filter-value-container">
              <span className="filter-value text-note ellipsis">{element}</span>
              <span id={element} className="remove-filter-btn" onClick={(e: any) => onRemove?.(element, e)}>
                <i className="ds3-icon ds3-close" />
              </span>
            </div>
          ))}
          <div className="filter-value-container">
            <span className="remove-filter-btn" onClick={() => setShowAll?.(true)}>
              +{values.length - 3}
            </span>
          </div>
        </>
      ) : (
        values.map((element) => (
          <div key={element} className="filter-value-container">
            <span className="filter-value text-note ellipsis">{element}</span>
            <span id={element} className="remove-filter-btn" onClick={(e: any) => onRemove?.(element, e)}>
              <i className="ds3-icon ds3-close" />
            </span>
          </div>
        ))
      )}
    </>
  )
}
